/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {Currency} from "./currency.zod";
import {Language} from "./language.zod";
import {NoteDto} from "./noteDto.zod";
import {OfferContent} from "./offerContent.zod";
import {OfferTemplateState} from "./offerTemplateState.zod";
import {TemplateEvaluation} from "./templateEvaluation.zod";

export const OfferTemplateDto = zod.object({
  offerTemplateId: zod.uuid(),
  name: zod.string(),
  state: OfferTemplateState,
  language: Language,
  currency: Currency,
  content: OfferContent,
  evaluation: TemplateEvaluation,
  notes: zod.array(NoteDto),
});

export type OfferTemplateDto = zod.input<typeof OfferTemplateDto>;
export type OfferTemplateDtoOutput = zod.output<typeof OfferTemplateDto>;
